import React, { useEffect, useState } from "react";
import { getRemaining, remainingLabel } from "../../utils/countdown";
import { useLang } from "../../context/LanguageContext";

// Renders a live-updating countdown label. Returns plain text so it can sit inline.
const Countdown = ({ expiresAt, fallback = "" }) => {
  const { t } = useLang();
  const [, force] = useState(0);
  useEffect(() => {
    if (!expiresAt) return;
    const t = setInterval(() => force((x) => x + 1), 1000);
    return () => clearInterval(t);
  }, [expiresAt]);
  if (!expiresAt) return <>{fallback}</>;
  return <>{remainingLabel(getRemaining(expiresAt), t)}</>;
};

export default Countdown;
